import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CircularProgress from 'material-ui/CircularProgress';
import utilFunction from '../../../containers/function';
import $ from 'jquery';

class CircularIndicator extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      id: 'component' + new Date().getTime() + '_' + Math.round(Math.random() * 10000)
    };
  }

  componentDidMount() {
    if (this.props.fill) {
      $('#component' + this.props.id + ' .circularBarWrapperValue circle').css(
        'fill',
        utilFunction.getColorCategory(this.props.graphColorRange, this.props.value, this.props.forceColor)
      );
    }
  }

  componentDidUpdate(prevProps) {
    if(this.props.forceColor!=prevProps.forceColor) {
      if (this.props.fill) {
        $('#component' + this.props.id + ' .circularBarWrapperValue circle').css(
          'fill',
          utilFunction.getColorCategory(this.props.graphColorRange, this.props.value, this.props.forceColor)
        );
      }      
    }
  }

  //IMPORTANTE: al usarlo, setear el estilo de circular-indicator al mismo tamaño (height) que se seteo en size
  render() {
    return (
      <section
        id={'component' + this.props.id}
        className={'circular-indicator' + (this.props.fill ? ' filled' : '')}
      >
        <div className="circularBarWrapper">
          <div className="circularBarWrapper">
            <CircularProgress
              mode="determinate"
              color="#eee"
              className="circularBar"
              value={this.props.max}
              max={this.props.max}
              size={this.props.size}
              thickness={this.props.thickness ? this.props.thickness : 7}
            />
          </div>
          <div className="circularBarWrapper circularBarWrapperValue">
            <CircularProgress
              mode="determinate"
              color={utilFunction.getColorCategory(this.props.graphColorRange, this.props.value, this.props.forceColor)}
              className="circularBar"
              value={this.props.forceValue ? this.props.forceValue : this.props.value}
              max={this.props.max}
              size={this.props.size}
              thickness={this.props.thickness ? this.props.thickness : 7}
            />
          </div>
        </div>
        <div
          className={'circularValue'}
          style={{
            fontSize: this.props.fontSize,
            color: this.props.fill
              ? '#fff'
              : utilFunction.getColorCategory(this.props.graphColorRange, this.props.value, this.props.forceColor)
          }}
        >
          {utilFunction.getFormatFunction(this.props.valueFormat)(this.props.value)}
        </div>
      </section>
    );
  }
}

export default CircularIndicator;



// WEBPACK FOOTER //
// ./source/client/components/common/indicators/circularIndicator.jsx